import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Flex } from "theme-ui";
export const DropDownContext = React.createContext(undefined);
export const DropDownBar = ({ open, children }) => {
    const ref = useRef(null);
    const [current, setLabel] = useState(open);
    const api = {
        current,
        toggle: (label) => {
            if (label === undefined) {
                setLabel(undefined);
            }
            else if (label === current) {
                setLabel(undefined);
            }
            else {
                setLabel(label);
            }
        }
    };
    useEffect(() => {
        const mouseListener = (ev) => {
            const isClickInside = current &&
                ev.target &&
                ev.target instanceof Element &&
                ref &&
                ref.current !== null &&
                ref.current.contains(ev.target);
            if (!isClickInside) {
                api.toggle(undefined);
            }
        };
        const escapeKeyListener = (ev) => {
            if (current && ev.key === "Escape") {
                api.toggle(undefined);
            }
        };
        if (typeof window !== "undefined") {
            window.document.addEventListener("mouseup", mouseListener);
            window.document.addEventListener("keydown", escapeKeyListener);
        }
        return () => {
            if (typeof window !== "undefined") {
                window.document.removeEventListener("mouseup", mouseListener);
                window.document.removeEventListener("keydown", escapeKeyListener);
            }
        };
    });
    return (_jsx(DropDownContext.Provider, { value: api, children: _jsx(Flex, { sx: { flexDirection: "row" }, ref: ref, children: children }) }));
};
//# sourceMappingURL=DropDownBar.js.map